import type { IconData } from '@stacksjs/iconify-core'

export const logoSnapchat: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 1.52h-1.52V0H3.04v1.52H1.52v1.53H0v25.9h1.52v1.53h1.52V32h25.91v-1.52h1.52v-1.53H32V3.05h-1.53Zm-3.05 21.34H25.9v1.52h-4.57v1.52h-3.05v1.53h-4.57V25.9h-3.05v-1.52H6.09v-1.52H4.57v-1.53h3.04v-1.52h1.53v-3.05H7.61v-1.52H6.09v-3.05h3.05v1.52h1.52V7.62h1.53V6.09h1.52V4.57h4.57v1.52h1.53v1.53h1.52v6.09h1.52v-1.52h3.05v3.05h-1.52v1.52h-1.53v3.05h1.53v1.52h3.04Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default logoSnapchat
